import { render, staticRenderFns } from "./ModalBulkDiscount.vue?vue&type=template&id=9ef8a39c&"
import script from "./ModalBulkDiscount.vue?vue&type=script&lang=js&"
export * from "./ModalBulkDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports